import { debugLog } from './debug';
import { closetAPI } from './api';

/**
 * Bulk-add closet items via the API.
 *
 * @param {Array} items - Items to add
 * @param {React.MutableRefObject} abortControllerRef - ref for AbortController
 * @param {React.MutableRefObject} timeoutIdRef - ref for timeout ID
 * @returns {Promise<{success: boolean, items_added: number, errors: string[]|null}>}
 */
export async function bulkAddClosetItems(items, abortControllerRef, timeoutIdRef) {
  debugLog('Bulk adding item count:', items.length);

  const controller = new AbortController();
  abortControllerRef.current = controller;
  const timeoutId = setTimeout(() => controller.abort(), 60000);
  timeoutIdRef.current = timeoutId;

  try {
    const response = await closetAPI.bulkAdd(items, controller.signal);
    const result = response.data;

    if (!result.success) {
      throw new Error(result.error || 'Failed to add items');
    }

    return result;
  } catch (err) {
    if (controller.signal.aborted) {
      const timeoutError = new Error('Bulk add timed out');
      timeoutError.name = 'AbortError';
      throw timeoutError;
    }
    throw err;
  } finally {
    clearTimeout(timeoutId);
    timeoutIdRef.current = null;
    abortControllerRef.current = null;
  }
}
